import { render, staticRenderFns } from "./LoyaltyDetails.vue?vue&type=template&id=3606ad81&scoped=true"
import script from "./LoyaltyDetails.vue?vue&type=script&lang=ts"
export * from "./LoyaltyDetails.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyDetails.vue?vue&type=style&index=0&id=3606ad81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3606ad81",
  null
  
)

export default component.exports